/* eslint-disable react-hooks/exhaustive-deps */
import { faRemove } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  AwardsItemProps,
  MainPrograms,
  Partner,
  StatusLevels,
  Program,
  linkedPartners
} from '..';
import { hideAlert, showAlert } from '../../../../components/alert/Alert';
import {
  InstructionWrapper,
  List,
  TextField
} from '../../../../components/fields';
import { Regexes } from '../../../../definitions';
import { awardProgramCategories } from '../../../../definitions/Categories';
import { AlertTypeEnum, StateTopicEnum } from '../../../../enums';
import { publish, useStateReducer } from '../../../../hooks';
import { getQueryParameter, validateObject } from '../../../../utilities';
import Heading from '../../../../_global/components/heading/Heading';
import { awardsDataService } from '../../services';
import './_styles.scss';
import { Reorder } from 'framer-motion';
import { parseFloatWithDecimal } from '../../../../utilities/stringUtils';

export default function EditItem({
  data: {
    main_program,
    display_program,
    category,
    status_levels = {
      level1: '',
      level2: '',
      level3: '',
      level4: '',
      level5: ''
    },
    programs = { name: '', partners: [{ program: '', ratio: 1 }] },
    currency = { value_cents: 0 },
    _id,
    listMainPrograms = [{ main_program: '' }]
  }
}: AwardsItemProps) {
  const location = useLocation();
  const mode = getQueryParameter(location.search, 'mode');
  let listLinkedPrograms: linkedPartners[] = [];
  const [state, setState] = useStateReducer({
    main_program,
    category,
    status_levels,
    programs,
    currency,
    display_program,
    listMainPrograms,
    listLinkedPrograms
  });

  const status_levels_keys = Object.keys(status_levels) as Array<
    keyof StatusLevels
  >;

  const handleState = (key: string, value: any) => {
    setState({ ...state, [key]: value });

    publish(StateTopicEnum.EditItem, state);
    publish(StateTopicEnum.IsValid, isValid());
  };

  const handleStateObj = (hanleMultiple: Object) => {
    setState({ ...state, ...hanleMultiple });

    publish(StateTopicEnum.EditItem, state);
    publish(StateTopicEnum.IsValid, isValid());
  };

  React.useEffect(() => {
    // Adds identifier to first item
    let { programs: aux } = state;
    aux.partners[0].program_name = state.display_program;
    aux.partners[0].program = state.main_program;
    handleState('programs', aux);

    (async function fetchMainPrograms() {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      listMainPrograms = await awardsDataService.getMainPrograms();
      listLinkedPrograms = await awardsDataService.getTransferPartners(
        main_program
      );

      state.listMainPrograms = listMainPrograms;
      state.listLinkedPrograms = listLinkedPrograms;

      state.programs.partners.map((element: Partner) => {
        element.ratio = parseFloatWithDecimal(element.ratio.toString(), 2);

        return element;
      });

      handleStateObj({
        listMainPrograms,
        listLinkedPrograms
      });
    })();
  }, []);

  const isValid = () => {
    if (errors['main_program']) return false;
    if (errors['display_program']) return false;
    if (errors['programs']) return false;
    if (errors['category']) return false;
    if (errors['programsPartners']) return false;
    return true;
  };

  const errors = validateObject(
    {
      main_program: {
        regex: Regexes.anyContentRegex,
        message: 'Main Program is required.'
      },
      category: {
        regex: Regexes.anyContentRegex,
        message: 'Category is required.'
      },
      display_program: {
        regex: Regexes.anyContentRegex,
        message: 'Display Program is required.'
      },
      programs: {
        func: (val: Program) => {
          if (val && val.name) return true;

          return false;
        },
        message: 'Program Name is required.'
      },
      programsPartners: {
        func: (val: Program) => {
          let tisValid = true;
          state.programs &&
            state.programs.partners.forEach((element: Partner) => {
              if (element.program === '' || element.ratio === 0)
                tisValid = false;
            });

          return tisValid;
        },
        message: 'Program Name is required.'
      }
    },
    state
  );

  React.useEffect(() => {
    publish(StateTopicEnum.EditItem, state);
    publish(StateTopicEnum.IsValid, isValid());

    // eslint-disable-next-line
  }, [state]);
  return (
    <div id='container-item' className='read-only'>
      <Heading name={state.main_program} style={{ margin: ' 0px' }} />

      <InstructionWrapper text='' row>
        <TextField
          readOnly={mode !== 'add'}
          label='Identifier'
          value={state.main_program}
          error={errors['main_program'] ? true : false}
          onChange={(event) => {
            let { programs: aux } = state;

            aux.partners[0].program = event.currentTarget.value;
            handleStateObj({
              main_program: event.currentTarget.value,
              programs: aux
            });
          }}
        />
        <TextField
          label='Partners Program Name'
          value={state.programs.name}
          error={errors['programs'] ? true : false}
          onChange={(event) => {
            state.programs.name = event.currentTarget.value;

            handleState('programs', state.programs);
          }}
        />
      </InstructionWrapper>

      <InstructionWrapper text='' row>
        <TextField
          label='Display Name of Program'
          error={errors['display_program'] ? true : false}
          value={state.display_program}
          onChange={(event) => {
            let { programs: aux } = state;
            aux.partners[0].program_name = event.currentTarget.value;
            handleStateObj({
              display_program: event.currentTarget.value,
              programs: aux
            });
          }}
        />
        <TextField
          label='Value (Cents)'
          value={state.currency.value_cents}
          error={errors['currency'] ? true : false}
          type={'number'}
          onChange={(event) => {
            let { currency: aux } = state;

            aux.value_cents = parseFloatWithDecimal(
              event.currentTarget.value,
              2
            );

            handleState('currency', aux);
          }}
        />

        <List
          className='top-margin'
          label={`Category`}
          value={state.category}
          error={errors['category'] ? true : false}
          options={awardProgramCategories}
          onChange={(_, v) => {
            if (!v) return;

            handleState('category', `${v}` ?? null);
          }}
          getOptionLabel={(o) => {
            return `${o}`;
          }}
          getOptionValue={(o) => {
            return `${o}`;
          }}
          groupBy={(o) => o.substring(0, 2)}
          isOptionEqualToValue={(o, v) => `${o}` === `${v}`}
        />
      </InstructionWrapper>

      <Heading name='Status Levels' />
      <div className='program-container'>
        {status_levels_keys &&
          status_levels_keys.map((k: keyof StatusLevels) => {
            return (
              <div key={k} className='program-card'>
                <TextField
                  className='full-width remove-auto-style'
                  label={k}
                  value={state.status_levels[k]}
                  onChange={(event) => {
                    state.status_levels[k] = event.currentTarget.value;
                    handleState('status_levels', state.status_levels);
                  }}
                ></TextField>
              </div>
            );
          })}
      </div>
      <Heading
        style={{ margin: '12px 0px' }}
        name='Transfer Partners'
        onClickRight={() => {
          if (!state.programs) {
            state.programs = { partners: [] };
          }

          let k: Partner = state.programs.partners.at(-1);

          if (!k || (k.program && k.ratio)) {
            let j: Partner = {
              program: '',
              ratio: 0
            };
            state.programs.partners.push(j);
            handleState('programs', state.programs);
          }
        }}
      />

      <Card className='program-card-edit page-padding'>
        <TextField value={1} style={{ width: '40px' }} readOnly></TextField>
        <TextField
          readOnly
          value={state.programs?.partners[0]?.program_name ?? ''}
          className='next-each-other'
          label={'Identifier'}
        ></TextField>

        <TextField
          readOnly
          className='next-each-other'
          label={'Ratio'}
          value={state.programs?.partners[0]?.ratio ?? ''}
          type={'number'}
        ></TextField>
      </Card>

      <Reorder.Group
        as='span'
        axis='y'
        className='program-card-container'
        values={state.programs.partners.filter(
          (partner: Partner, index: number) => index !== 0
        )}
        onReorder={(newOrder: any[]) => {
          let aux = { ...state.programs };
          aux.partners = [state.programs?.partners[0], ...newOrder];
          handleState('programs', aux);
        }}
      >
        {state.programs.partners
          .filter((partner: Partner, index: number) => index !== 0)
          .map((partner: Partner, index: number) => {
            index++;
            let mainp: MainPrograms = {
              main_program: partner.program,
              display_program: partner.program_name
            };
            let child;

            child = (
              <Card
                key={partner.program}
                className='program-card-edit page-padding'
              >
                <FontAwesomeIcon
                  className={'remove-program'}
                  icon={faRemove}
                  onClick={() => {
                    if (state.programs.partners.length === 1) {
                      showAlert({
                        content: 'Unable to remove last partner.',
                        options: {
                          actions: [
                            {
                              text: 'Okay',
                              onClick: hideAlert,
                              primary: true
                            }
                          ],
                          type: AlertTypeEnum.Warning
                        }
                      });
                      return;
                    }

                    if (index > -1) {
                      state.programs.partners.splice(index, 1);
                    }
                    handleState('programs', state.programs);
                  }}
                />
                <TextField
                  value={index + 1}
                  style={{ width: '40px' }}
                  readOnly
                  error={errors['programsPartners'] ? true : false}
                ></TextField>
                <List
                  className='next-each-other'
                  label={`Identifier`}
                  value={mainp}
                  error={mainp.main_program === ''}
                  options={state.listMainPrograms.filter(
                    (mainProgram: MainPrograms) =>
                      !state.programs.partners.some(
                        (e: Partner) => e.program === mainProgram.main_program
                      )
                  )}
                  onChange={(_: any, v: MainPrograms) => {
                    state.programs.partners[index].program = v.main_program;
                    state.programs.partners[index].program_name =
                      v.display_program;

                    handleState('programs', state.programs);
                  }}
                  getOptionLabel={(o: MainPrograms) => {
                    return o.display_program ?? '';
                  }}
                  getOptionValue={(o: MainPrograms) => {
                    return o.display_program ?? '';
                  }}
                  groupBy={(o: MainPrograms) => {
                    return `${o.display_program?.substring(0, 4) ?? ''}`;
                  }}
                  isOptionEqualToValue={(o: MainPrograms, v: MainPrograms) => {
                    return o.display_program === v.display_program;
                  }}
                />

                <TextField
                  className='next-each-other'
                  label={'Ratio'}
                  value={partner.ratio}
                  type={'number'}
                  error={partner.ratio === 0}
                  onChange={(event) => {
                    state.programs.partners[index].ratio =
                      parseFloatWithDecimal(event.currentTarget.value, 2);

                    if (state.programs.partners[index].ratio < 0)
                      state.programs.partners[index].ratio = 0;
                    handleState('programs', state.programs);
                  }}
                ></TextField>
              </Card>
            );

            return (
              <Reorder.Item
                key={partner.program}
                value={partner}
                drag={index !== 0}
                draggable={index !== 0}
                className={index === 0 ? `margin-bottom` : ''}
                style={index === 0 ? {} : {}}
              >
                {child}
              </Reorder.Item>
            );
          })}
      </Reorder.Group>

      <Heading style={{ margin: '12px 0px' }} name='Linked Partners' />

      <div className='program-card-grid'>
        {state &&
          state.listLinkedPrograms &&
          state.listLinkedPrograms.map(
            (partner: linkedPartners, index: number) => {
              return (
                <Card
                  key={`${partner.display_program}-${index}`}
                  className='linked-transfer'
                >
                  <TextField
                    readOnly
                    className='next-each-other'
                    label={'Linked Program'}
                    value={partner.display_program}
                  ></TextField>

                  <TextField
                    readOnly
                    className='next-each-other'
                    label={'Ratio'}
                    value={partner.ratio}
                    type={'number'}
                  ></TextField>
                </Card>
              );
            }
          )}
      </div>
    </div>
  );
}
